import React from 'react';
import logo from './logo.jpg';
import Upload from "./upload/Upload";
import ImageLoader from "./imageLoader";
import DumbButton from "./dumbButton";
import './App.css';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import {Button, Col, Row,Container, Jumbotron,Card, ToggleButton, Form, Spinner} from 'react-bootstrap';
import {
  Switch,
  Route,
  NavLink,
  useLocation
} from "react-router-dom";
import Img from 'react-image';
import ReactPlayer from 'react-player'
import { motion, AnimatePresence } from "framer-motion"
var myUploadComponent = <Upload />;
//window.$fileName = '';

const pageVariants = {
  initial: {
    opacity: 0,
    y: "-200vw",
    scale: 0.8
  },
  in: {
    opacity: 1,
    y: 0,
    scale: 1
  },
  out: {
    opacity: 0,
    y: "200vw",
    scale: 1.2
  }
};

const page1Variants = {
  initial: {
    opacity: 0,
    y: "400vw",
    scale: 0.8
  },
  in: {
    opacity: 1,
    y: 0,
    scale: 1
  },
  out: {
    opacity: 0,
    y: "-400vw",
    scale: 1.2
  }
};
const buttonVariants = {
    initial: {
    opacity: 0,
    y: "400vw",
    scale: 0.8
  },
  in: {
    opacity: 1,
    y: 0,
    scale: 1,
  },
  out: {
    opacity: 0,
    y: "-400vw",
    scale: 1.2
  }
};



const pageTransition = {
  type: "tween",
  ease: "anticipate",
  duration: 1.2
};

function App() {
  const location = useLocation();
  return (
      <div>

        {/*
          A <Switch> looks through all its children <Route>
          elements and renders the first one whose path
          matches the current URL. Use a <Switch> any time
          you have multiple routes, but you want only one
          of them to render at a time
        */}
        <AnimatePresence exitBeforeEnter>
        <Switch location={location} key={location.pathname}>
              <Route path="/About" component={About} />
              <Route path="/Help" component={Help} />
              <Route path="/" exact component={Home} />
              <Route path="/Get-Started" exact component={Select}/>
              <Route path="/Select" exact component={Select}/>
              <Route path="/Options" exact component={Options}/>
              <Route path="/LoadImage" exact component={LoadImage}/>
        </Switch>
        </AnimatePresence>
      </div>
  );
}

function Home() {
  return (
    <motion.div initial="initial"
                animate="in"
                exit="out"
                variants={pageVariants}
                transition={pageTransition}
                className="App">
      <p><br></br><br></br><br></br></p>
      <motion.img src={logo} className="App-logo" initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}/>
      <Container>
        <Row>
          <Col>
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.9 }} 
                initial="initial"
                animate="in"
                exit="out"
                variants={buttonVariants}
                >  
            <NavLink to="/About">
              <Button variant="danger" size="lg" block>
               About
              </Button>
            </NavLink>
            </motion.div>
          </Col>
          <Col> 
          <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.9 }} 
                initial="initial"
                animate="in"
                exit="out"
                variants={buttonVariants}>
             <NavLink to="/Select">           
            <Button style = {{color: "white"}} variant="primary" size="lg" block>
              Get Started
            </Button>
            </NavLink>
          </motion.div>
          </Col>
          <Col>            
          <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.9 }}
                initial="initial"
                animate="in"
                exit="out"
                variants={buttonVariants}> 
             <NavLink to="/Help">          
            <Button style = {{color: "white"}} variant="success" size="lg" block>
              Help
            </Button>
            </NavLink>
          </motion.div>
          </Col>
        </Row>
    </Container>
    </motion.div>  
  );
}

function About() {
  return (
    <motion.div initial="initial"
                animate="in"
                exit="out"
                variants={page1Variants}
                transition={pageTransition}
                className="App">
      <p className="text-right mt-4 mb-4">
          <NavLink to="/About">
            <Button variant="danger" size="lg" >
               About
            </Button>
          </NavLink>
          <NavLink to="/Select">
              <Button  style = {{color: "white"}} variant="primary" size="lg" >
                Get Started
              </Button>
          </NavLink>
          <NavLink to="/Help">
              <Button  style = {{color: "white"}} variant="success" size="lg" >
               Help
              </Button>
          </NavLink>
      </p>
      <h1 >About</h1>
      <p><br></br></p>
<Container>
  <Row>
    <Col>
      <Jumbotron>
        <h2 className="App">Welcome to MosaIT</h2>
        <p><br></br>
            MosaIT is a CS 426 Senior Project in Computer Science, Spring 2020, at UNR, CSE Department.
        </p>
        <p>
            MosaIT is an image processing web application. It takes input from the user in the form of an image and a search term.
            A photo mosaic of the user’s image is then constructed from images found on the web tagged with the user’s search term.
            The result will be an image, comprised of many smaller images, that is consistent with the target image.
        </p>
	  <ReactPlayer url='https://www.youtube.com/watch?v=QWn1ObE-CEw'
	      controls className='react-player' width = "100" /> 
	  
      </Jumbotron>
    </Col>
  </Row>
  </Container>
   <h2 >Meet Team 26</h2>   
   <p><br></br></p>
   <Container>
    <Row>
      <Col>
        <Card bg="danger" text="white" >
          <Card.Body>
            <Card.Title>Jared Manning</Card.Title>
            <Card.Text>
            </Card.Text>
          </Card.Body>
        </Card>
      </Col>
      <Col>
        <Card bg="primary" text="white" >
          <Card.Body>
            <Card.Title>Michael Reyes</Card.Title>
            <Card.Text>
            </Card.Text>
          </Card.Body>
        </Card>
      </Col>
      <Col>
        <Card bg="success" text="white" style={{ width: '17.5rem' }}>
          <Card.Body>
            <Card.Title>Egan Sutherland</Card.Title>
            <Card.Text>
            </Card.Text>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  </Container>
 <p><br></br></p>
  <p><br></br></p>
  <h2 >Instructors and External Advisors</h2>   
   <p><br></br></p>
   <Container>
    <Row>
      <Col>
        <Card bg="danger" text="white" >
          <Card.Body>
            <Card.Title>Devrin Lee</Card.Title>
            <Card.Text>
            Instructor
            </Card.Text>
	    <Card.Text>
	     Department of Computer Science and Engineering, UNR
	    </Card.Text>
          </Card.Body>
        </Card>
      </Col>
      <Col>
        <Card bg="primary" text="white">
          <Card.Body>
            <Card.Title>Dr. Mircea Nicolescu</Card.Title>
            <Card.Text>
            External Advisor
            </Card.Text>
	              <Card.Text>
	              Department of Computer Science and Engineering, UNR
	              </Card.Text>
          </Card.Body>
        </Card>
      </Col>
      <Col>
        <Card bg="success" text="white">
          <Card.Body>
            <Card.Title>Dr. Sergiu Dascalu</Card.Title>
            <Card.Text>
            Instructor
            </Card.Text>
	              <Card.Text>
	              Department of Computer Science and Engineering, UNR
	              </Card.Text>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  </Container>
<p><br></br></p>
<p><br></br></p>
<Container>
  <Row className="justify-content-md-center">
    <Col xs={10}>
      <Jumbotron>
        <p>
          <b>Project Related Resources:</b>
        <br/>
        Gonzalez, R. C., and R. E. Woods. Digital Image Processing. Prentice Hall, 2008<br/>
        “OpenCV Modules.” OpenCV, docs.opencv.org/4.1.2/.<br/>
        “Getting Started.” React, reactjs.org/docs/getting-started.html<br/>
        “Getting Started with Redux · Redux.” Redux, redux.js.org/introduction/getting-started.<br/>
        “Scrapy 1.8 Documentation.” Scrapy 1.8 Documentation - Scrapy 1.8.0 Documentation, docs.scrapy.org/en/latest/index.html
        </p>
      </Jumbotron>
    </Col>
  </Row>
  </Container>
    </motion.div>
  );
}

function Help() {
  return (
      <motion.div initial="initial"
                animate="in"
                exit="out"
                variants={pageVariants}
                transition={pageTransition}
                >
                <p className="text-right mt-4 mb-4">
          <NavLink to="/About">
            <Button variant="danger" size="lg" >
               About
            </Button>
          </NavLink>
          <NavLink to="/Select">
              <Button  style = {{color: "white"}} variant="primary" size="lg" >
                Get Started
              </Button>
          </NavLink>
          <NavLink to="/Help">
              <Button  style = {{color: "white"}} variant="success" size="lg" >
               Help
              </Button>
          </NavLink>
      </p>
      <h1 className="App"> Help</h1>
      <p><br></br></p>
      <Container>
  		<Row>
    	<Col>
      		<Jumbotron>
        		<h2 className="App">Instructions</h2>
        			<p className = "App">
              MosaIT allows you to generate unique photo mosaics of any picture you upload.</p>
	  <p>
	  The steps to do so are as follows:<br></br> 
	      1. Click "Get Started"<br></br>
	      2. Click on the "Upload Files" circular button on the left<br></br>
	      3. Click the purple "Upload" button and select an image using your device's file explorer <br></br>
	      4. Wait for the loading bar to fill then click "Continue" <br></br>
	      5. Next, enter a search term in the first box. It can be anything. This is what MosaIT will search for when gathering images for your personalized photo mosaic.<br></br>
	      6. Two drop down menus follow that. One for the height and one for the width of your mosaic. This determines the number of pictures that make up your mosaic.<br></br>
	      7. At this point, press generate or use the tick boxes in Advanced Options for additional customization. The first of these options, "Allow repeated images", allows MosaIT to use the same images multiple times throughout your mosaic. The second option, "Blend the mosaic with your image", will create a mosaic that combines the mosaic with your original image. This puts more weight on the mosaic and just brings out some details that were in your original image. The third option is to use a pre-defined set of images to build the mosaic. This set of images contains images of pets, birds, nature, and ocean. Using this option significantly reduces the build time of the mosaic.<br></br>
	     8. Wait for your mosaic to generate. BE PATIENT! There will be a results spinner that is replaced with your photo mosaic when complete. Mosaic generation can take anywhere from 5 to 15 minutes, depending on the search term, size of the mosaic, and site traffic.<br></br>
	      9. Look at your fresh mosaic! Download it by right-clicking the image and selecting "Save Image as" or click "Home" in the top left to start another.
            		<br></br>
        			 </p>
        		<h2 className="App">Contact Us</h2>
            		<p className="App">Email: mosaitart@gmail.com </p>  		
      		</Jumbotron>
    	</Col>
  		</Row>
  	  </Container>
    </motion.div>
  );
}

function Start() {
  return (
      <motion.div initial="initial"
                animate="in"
                exit="out"
                variants={pageVariants}
                transition={pageTransition}
                className="App">
                <p className="text-right mt-4 mb-4">
          <NavLink to="/About">
            <Button variant="danger" size="lg" >
               About
            </Button>
          </NavLink>
          <NavLink to="/">
              <Button  style = {{color: "white"}} variant="primary" size="lg" >
                Home
              </Button>
          </NavLink>
          <NavLink to="/Help">
              <Button  style = {{color: "white"}} variant="success" size="lg" >
               Help
              </Button>
          </NavLink>
      </p>
      <h1>MosaIT Creator</h1>
      <p><br></br></p>
      What type of MosaIT do you want to create?
      <p><br></br></p>
      <Container>
  		<Row className="justify-content-md-center">
    	<Col>
    	    <ToggleButton type="radio" name="radio" value="2">
      			Photo MosaIT
    		</ToggleButton>
    	</Col>
    	<Col>
    		<ToggleButton type="radio" variant="secondary" name="radio" value="2" disabled>
      			Video MosaIT
    		</ToggleButton>
    	</Col>
  		</Row>
  		<p><br></br></p>
  		<p><br></br></p>
  		<p><br></br></p>
  		<Row className="justify-content-md-center">
  		<NavLink to="/Select">
  		      <Button  style = {{color: "white"}} variant="success" size="lg" >
                Continue
              </Button>
        </NavLink>
  		</Row>
  	  </Container>
    </motion.div>
  );
}

function Select() {
  return (
      <motion.div initial="initial"
                animate="in"
                exit="out"
                variants={pageVariants}
                transition={pageTransition}
                className="App">
                <p className="text-right mt-4 mb-4">
          <NavLink to="/About">
            <Button variant="danger" size="lg" >
               About
            </Button>
          </NavLink>
          <NavLink to="/">
              <Button  style = {{color: "white"}} variant="primary" size="lg" >
                Home
              </Button>
          </NavLink>
          <NavLink to="/Help">
              <Button  style = {{color: "white"}} variant="success" size="lg" >
               Help
              </Button>
          </NavLink>
      </p>
      <h1>MosaIT Creator</h1>
      <p><br></br></p>

	<Container>
  		<Row className="justify-content-md-center">
    	<Col xs={10}>
      		<Jumbotron>
        		<h2 className="App">Upload the Photo you want to MosaIT</h2>
            {myUploadComponent}
      		</Jumbotron>
    	</Col>
  		</Row>
        <Row className="justify-content-md-center">
    	<Col xs={4}>
         <NavLink to="/">
            <Button variant="danger" size="lg" block>
               Go Back
            </Button>
          </NavLink>
    	</Col>
       <Col xs={4}>
          <DumbButton/>
    	</Col>
  		</Row>
  	  </Container>
  	   <p><br></br></p>
    </motion.div>
  );
}
  function Options() {
  return (
      <motion.div initial="initial"
                animate="in"
                exit="out"
                variants={pageVariants}
                transition={pageTransition}
                className="App">
                <p className="text-right mt-4 mb-4">
          <NavLink to="/About">
            <Button variant="danger" size="lg" >
               About
            </Button>
          </NavLink>
          <NavLink to="/">
              <Button  style = {{color: "white"}} variant="primary" size="lg" >
                Home
              </Button>
          </NavLink>
          <NavLink to="/Help">
              <Button  style = {{color: "white"}} variant="success" size="lg" >
               Help
              </Button>
          </NavLink>
      </p>
      <h1>MosaIT Creator</h1>
      <p><br></br></p>

	<Container>
<Jumbotron>
	   <Form>
	   <h2>MosaIT Options</h2>
  <Form.Group controlId="exampleForm.ControlInput1">
    <Form.Label>What images will the MosaIT be made of?</Form.Label>
    <Form.Control type="text" placeholder="Birds" onChange={e => sessionStorage.setItem("Term", e.target.value)}/>
  </Form.Group>
  <Form.Group controlId="exampleForm.ControlSelect1">
    <Form.Label>What will be the height of your MosaIT?</Form.Label>
    <Form.Control as="select" onChange={e => sessionStorage.setItem("Height", e.target.value)}>
      <option></option>
      <option>16</option>
      <option>24</option>
      <option>32</option>
      <option>40</option>
      <option>48</option>
      <option>64</option>
    </Form.Control>
  </Form.Group>
  <Form.Group controlId="exampleForm.ControlSelect11">
	<Form.Label>What will be the width of your MosaIT?</Form.Label>
           <Form.Control as="select" onChange={e => sessionStorage.setItem("Width", e.target.value)}>
	        <option></option>
	        <option>16</option>
	        <option>24</option>
                <option>32</option>
                <option>40</option>
                <option>48</option>
                <option>64</option>
         </Form.Control>
  </Form.Group>
	  <p><br></br></p>
	  <h2><small><b>Advanced Options:</b></small></h2>
	 <Form.Group controlIwd="exampleForm.ControlSelect2">
	  {['checkbox'].map(type => (
		      <div key={`default-${type}`}>
		        <Form.Check 
		          type={type}
		          id={`default-${type}`}
		          label={'Allow repeated images'}
		          onChange={e => sessionStorage.setItem("Repeat", e.target.value)}
		        />

		        <Form.Check
		          type={type}
		          label={'Blend the mosaic with your image'}
		          onChange={e => sessionStorage.setItem("Blend", e.target.value)}
		          id={`disabled-default-${type}`}
		        />
		    
		        <Form.Check
		          type={type}
		          label={'Use our image set (this will replace your search term)'}
		          id={`disabled-default-${type}`}
		          onChange={e => sessionStorage.setItem("Default", e.target.value)}
		         />
		                        </div>
		    ))}
	    </Form.Group>
  </Form>
 </Jumbotron>
        <Row className="justify-content-md-center">
    	<Col xs={4}>
         <NavLink to="/Select">
            <Button variant="danger" size="lg" block>
               Go Back
            </Button>
          </NavLink>
    	</Col>
       <Col xs={4}>
          <NavLink to="/LoadImage">
              <Button  style = {{color: "white"}} variant="success" size="lg" block onClick ={generateMosait}>
               Generate
              </Button>
          </NavLink>
    	</Col>
  		</Row>
        
  	  </Container>
        
  	   <p><br></br></p>
    </motion.div>
  );
}

function LoadImage() {
  return (
      <motion.div initial="initial"
                animate="in"
                exit="out"
                variants={pageVariants}
                transition={pageTransition}
                className="App">
                <p className="text-right mt-4 mb-4">
          <NavLink to="/About">
            <Button variant="danger" size="lg" >
               About
            </Button>
          </NavLink>
          <NavLink to="/Get-Started">
              <Button  style = {{color: "white"}} variant="primary" size="lg" >
                Get Started
              </Button>
          </NavLink>
          <NavLink to="/Help">
              <Button  style = {{color: "white"}} variant="success" size="lg" >
               Help
              </Button>
          </NavLink>
      </p>
      <h1>Result</h1>
      <p><br></br></p>
      <Container>
      <Row>
      <Col>
     
             <ImageLoader imageLink = {sessionStorage.getItem("filePath")}/>  
      </Col>
      </Row>
      </Container>
    </motion.div>
  );
}

async function generateMosait() {
     const promises = [];
     const fileName = sessionStorage.getItem("fileName");
     const term = sessionStorage.getItem("Term");
     const width = sessionStorage.getItem("Width");
     const height = sessionStorage.getItem("Height");
     const repeat = sessionStorage.getItem("Repeat");
     const blend = sessionStorage.getItem("Blend");
     const defaultSet = sessionStorage.getItem("Default");	
     promises.push(sendRequest(term,height,width,fileName,repeat,blend,defaultSet));
    try {
      await Promise.all(promises);
    } catch (e) {
      console.log(e)
    }
  }

 function sendRequest(Term, Height, Width, FileName, Repeat, Blend, defaultSet) {
    return new Promise((resolve, reject) => {
      const req = new XMLHttpRequest();
      const formData = new FormData();
      const data = Term + "`" + Width + "`" + Height + "`" + FileName+"`"+Repeat+"`"+Blend+"`"+defaultSet;
      formData.append("data", data);
      req.open("POST", "http://mosait.art:9001/generateMosait");
      req.send(formData);

    });
  }
export default App;
